const audFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  maximumFractionDigits: 0,
});

export function formatAud(n: number): string {
  return audFormatter.format(Math.round(n));
}

const audCodeFormatter = new Intl.NumberFormat('en-AU', {
  maximumFractionDigits: 0,
});

/**
 * AUD amount with an explicit "AUD" code prefix, e.g. `AUD 150,000`.
 * Used where the currency must be unambiguous next to a foreign-currency
 * figure (the plain `$` from `formatAud` reads as USD/SGD/HKD too).
 */
export function formatAudCode(n: number): string {
  return `AUD ${audCodeFormatter.format(Math.round(n))}`;
}

export function formatPercent(n: number, decimals = 1): string {
  return `${(n * 100).toFixed(decimals)}%`;
}

export function formatPercentFromPct(n: number, decimals = 1): string {
  return `${n.toFixed(decimals)}%`;
}

/** Replace `{token}` placeholders in a template with resolved values. */
export function interpolate(
  template: string,
  values: Record<string, string | number>,
): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    key in values ? String(values[key]) : match,
  );
}
